import React from "react";
import Sidebar from "../../components/Layout/Sidebar/Sidebar";
import CalendarMain from "./../../components/Layout/Calendar/CalendarMain";

export default function CalendarPage() {
  return (
    <>
      <Sidebar />
      <CalendarMain />
    </>
  );
}
